<template>

<!-- CODE for hiding this if not -->


  <form action="/action_page.php"  @submit.prevent="registerTutor" class="form new-border">
    <h2 class="form-heading">Become a tutor</h2>

   <input
      class="form-input new-border-inset"
      type="text"
      v-model="fullname"
      placeholder="Full name"
      required
    />
    <input
      class="form-input new-border-inset"
      type="text"
      v-model="username"
      placeholder="Username"
      required
    /> 
      <input
      class="form-input new-border-inset"
      type="Password"
      v-model="password"
      placeholder="password"
      required
    /> 

     <input
      class="form-input new-border-inset"
      type="email"
      v-model="email"
      placeholder="Email"
      
    />


    <input
      class="form-input new-border-inset"
      type="grades"
      v-model="grades"
      placeholder="Grades"
    />

  <input
      class="form-input new-border-inset"
      type="text"
      v-model="contact"
      placeholder="Contact number"
      
    />

     <input
      class="form-input new-border-inset"
      type="text"
      v-model="location"
      placeholder="Location"
      
    />

  
     <input
      class="form-input new-border-inset"
      type="text"
      v-model="subject"
      placeholder="Subject"
      
    />

     <input
      class="form-input new-border-inset"
      type="img"
      v-model="img"
      placeholder="img url"
    />

      <input
      class="form-input new-border-inset"
      type="document"
      v-model="document"
      placeholder="document"
    />

<!-- 

        <p class="">Required Document</p>
    <input
     
      class="form-input new-border-inset"
      placeholder="Document"
       type="file"
      required
    />
    <p class="">Profile Image</p>
 <input type="file" id="myFile" name="filename">
    <input
     
      class="form-input new-border-inset"
      placeholder="Image url"
       type="file"
      required
    />
   -->
    <button to="/" type="submit" class="text-success   form-btn new-border">Become a tutor</button>
    <!-- <div class="form-social-login">
      <button class="form-btn new-border form-social-btn">
        <i class="fab fa-google"></i>
      </button>
      <button class="form-btn new-border form-social-btn">
        <i class="fab fa-facebook-f"></i>
      </button>
    </div> -->

    <!-- <p>
      Already a member?
      <router-link :to="{ name: 'Login' }">Sign in</router-link>
    </p> -->
  </form>
</template>
<script>
export default {
// POST TUTORS HERE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  data() {
    return {
      fullname: "",
      username: "",
      img: "",
      email: "",
      subject: "",
      contact: "",
      password: "",
      grades: "",
      location: "",
      document: ""



    };
  },
  
  methods: {
    registerTutor() {
      const dta = [{
          username: this.username,
          fullname: this.fullname,
          email: this.email,
          img: this.img,
          subject: this.subject,
          grades: this.grades,  
          location: this.location,
          contact: this.contact,
          password: this.password,
          document: this.document

        }]
        console.table(dta)
      // console.log(this.fullname, this.username, this.email, this.contact, this.img, this.subject, this.password, this.grades, this.location, this.document);
      fetch("https://thuto-backend.herokuapp.com/auth/register-tutor", {
        method: "POST",
        body: JSON.stringify({
          username: this.username,
          fullname: this.fullname,
          email: this.email,
          img: this.img,
          subject: this.subject,
          grades: this.grades,  
          location: this.location,
          contact: this.contact,
          password: this.password,
          document: this.document

        }),
        // mode: 'no-cors',
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      })
        .then((response) => response.json())
        .then((json) => {
          alert("Tutor application successfully sent");
          localStorage.setItem("jwt", json.jwt);
          this.$router.push({ name: "Home" });
        })
        .catch((err) => {
          alert(err);
        });
    },
  },
};
</script>
<style>
.new-border {
  border-radius: 30px;
  background: #f5f5f5;
  box-shadow: 8px 8px 15px #e4e4e4, -8px -8px 15px #ffffff;
}
.new-border-inset {
  border-radius: 30px;
  background: #f5f5f5;
  box-shadow: inset 8px 8px 15px #e4e4e4, inset -8px -8px 15px #ffffff;
}
.form {
  
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 40px;
  gap: 20px;
  width: 100%;
  max-width: 600px;
  margin-inline: auto;
}
.form-heading {
  text-align: center;
  text-transform: uppercase;
}
.form-input,
.form-btn {
  border: none;
  outline: none;
  padding: 20px;
}
.form-btn {
  cursor: pointer;
  transition: all 0.1s linear;
}
.form-btn:hover {
  transform: scale(1.05);
}
.form-social-login {
  display: flex;
  justify-content: space-between;
}
.form-social-btn {
  width: 45%;
  color: rgb(255, 190, 190);
  
}


</style>